import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MonitorProduct } from 'src/app/pages/area/area.model';
import { BaseAccordionComponent } from '../base-accordion.component';
import { VisitDayDetailsService } from '../../visit-day-details.service';
import { AccordionService } from 'src/app/services/accordion.service';
import { DocumentsListApiService } from '../visit-documents/visit-documents.service';
import { SnackbarService } from '@bcl/design-system';

@Component({
  selector: 'app-visit-detail-products',
  templateUrl: './visit-detail-products.component.html',
  styleUrls: ['./visit-detail-products.component.scss'],
})
export class VisitDetailProductsComponent extends BaseAccordionComponent {
  @Input() products: MonitorProduct[];
  @Input() visit?: any; // Add visit input
  @Input() isEditingDisabled = false;
  @Output() editProductEvent = new EventEmitter<ProductEmitEvent>();
  @Output() addProductEvent = new EventEmitter<void>();

  public downloadingMsds = false;

  constructor(
    accordionService: AccordionService,
    private documentsApiService: DocumentsListApiService,
    private snackbarService: SnackbarService
  ) {
    super(accordionService);
  }

  // Computed property to check if form should be disabled
  get isFormDisabled(): boolean {
    return this.isEditingDisabled;
  }

  public editProduct($event: MonitorProduct) {
    const productEmitEvent: ProductEmitEvent = {
      product: $event,
      eventType: 'replace',
    };
    this.editProductEvent.emit(productEmitEvent);
  }

  public editProductWarehouse($event: MonitorProduct) {
    const productEmitEvent: ProductEmitEvent = {
      product: $event,
      eventType: 'storeInWarehouse',
    };
    this.editProductEvent.emit(productEmitEvent);
  }

  public deleteProduct($event: MonitorProduct) {
    const productEmitEvent: ProductEmitEvent = {
      product: $event,
      eventType: 'delete',
    };
    this.editProductEvent.emit(productEmitEvent);
  }

  public addProduct() {
    this.addProductEvent.emit();
  }

  public downloadMsds(product: MonitorProduct) {
    if (!product.msdsReferenceId) {
      return;
    }

    product.downloading = true;
    this.downloadingMsds = true;

    this.documentsApiService.downloadFile(product.msdsReferenceId).subscribe({
      next: (blob) => {
        const fileName = product.msdsReferenceName || `MSDS_${product.name}`;
        this.documentsApiService.downloadFileToDisk(blob, fileName);

        this.snackbarService.open(
          'green',
          'DOCUMENTS_LIST.MESSAGES.DOWNLOAD_DOCUMENT_SUCCESS'
        );

        product.downloading = false;
        this.downloadingMsds = false;
      },
      error: () => {
        this.snackbarService.open(
          'red',
          'DOCUMENTS_LIST.MESSAGES.DOWNLOAD_DOCUMENT_ERROR'
        );

        product.downloading = false;
        this.downloadingMsds = false;
      },
    });
  }
}

export type ProductEmitEvent = {
  product: MonitorProduct;
  eventType: string;
};
